"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NFTStorageClient = void 0;
const nft_storage_1 = require("nft.storage");
const lodash_1 = require("lodash");
class NFTStorageClient {
    constructor({ token }) {
        this.token = token;
        this.client = new nft_storage_1.NFTStorage({ token: token });
    }
    storeImageFromUrl({ name, description, imageUrl, }) {
        return __awaiter(this, void 0, void 0, function* () {
            const slugifiedName = (0, lodash_1.kebabCase)(name);
            const fileType = "image/jpeg"; // onl support jpeg
            // get data from file
            const blob = yield (yield fetch(imageUrl)).blob();
            const metadata = yield this.client.store({
                name: name,
                description: description,
                image: new nft_storage_1.File([blob], `${slugifiedName}.jpg`, {
                    type: fileType,
                }),
            });
            return metadata.url;
        });
    }
    store({ name, description, imageFile, }) {
        return __awaiter(this, void 0, void 0, function* () {
            const slugifiedName = (0, lodash_1.kebabCase)(name);
            // get data from file
            const blob = new Blob([imageFile], { type: imageFile.type });
            const metadata = yield this.client.store({
                name: name,
                description: description,
                // TODO: change extension based on type
                image: new nft_storage_1.File([blob], `${slugifiedName}.jpg`, {
                    type: imageFile.type,
                }),
            });
            return metadata.url;
        });
    }
}
exports.NFTStorageClient = NFTStorageClient;
